// Instant quote function component
// This version only call the onQuoteRequest function, delegate logic to slices
import React from 'react';
import PropTypes from 'prop-types';

const InstantQuote = ({ className, label, onQuoteRequest }) => (
  <div className="mb-3 d-grid">
    <button
      type="button"
      className={className}
      onClick={() => onQuoteRequest()}>
      {label}
    </button>
  </div>
)

InstantQuote.defaultProps = {
  className: 'btn btn-main-action',
  label: 'QUOTE',
};

InstantQuote.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  onQuoteRequest: PropTypes.func.isRequired,
}

export default InstantQuote;
